// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1GITw","rootSuccess":"CompleteLink_rootSuccess__1OSQC","rootFailure":"CompleteLink_rootFailure__hts9A","isDisabled":"CompleteLink_isDisabled__2j_4k"};